<template>
  <div>
    <h4>审批表单</h4>
    <approveTable />
  </div>
</template>

<script>
import approveTable from './approveTable'

export default {
  name: 'approvalForm',
  data() {
    return {}
  },
  components: {
    approveTable,
  },
}
</script>

<style>

</style>
